module.exports = __webpack_public_path__ + "static/img/device_hy_s4.6fd538a9.png";